import React, { useState, useEffect } from "react";
import { getRequest } from "sharedUtils/httpUtils";
import { getAuthorizedUserData } from "sharedUtils/authUtils";
import ProductSelectCard from "components/ProductSelectCard";
import LoadSpinner from "components/LoadSpinner";
import InfiniteScroll from "react-infinite-scroll-component";

/**
 * 
 * @param {{postShareCode:string, existingProducts:object[], selectProduct:Function, selectedProducts:object[], searchFilter:string, deviceSize:string}} props
 */
const ProductsSelectorForm = (props) => {
    let [products, setProducts] = useState([]);
    let [links, setLinks] = useState([]);
    let [productsLinks, setProductsLinks] = useState([]);
    let [filteredProducts, setFilteredProducts] = useState([]);
    let [loggedInUser, setUser] = useState({});
    let [loading, setLoading] = useState(true);
    let [loadingMore, setLoadingMore] = useState(false);
    let [take, setTake] = useState(100);
    let [searchProp, setSearchProp] = useState("");
    let [finishedFetchingProducts, setFinishedFetchingProducts] = useState(false);
   
    function concatMerchantProduct(product) {
        if (product.name.toLowerCase().indexOf(product.manufacturer.toLowerCase()) === 0) {
            return product.name;
        }
        return (product.manufacturer + ' ' + product.name).trim();
    }

    async function loadData(skip, take) {
        setLoading(true);
        let products = await fetchProducts();
        let links = await fetchLinks();

        // Combine products and links
        let combinedArray = [...links, ...products];

        // Helper function to check if a date is valid

        // Sort the combined array
        let filteredProductsLinks = combinedArray.sort((a, b) => {
            let dateA = isValidDate(new Date(a.modifiedDate)) ? new Date(a.modifiedDate) : new Date(a.createdDate);
            let dateB = isValidDate(new Date(b.modifiedDate)) ? new Date(b.modifiedDate) : new Date(b.createdDate);

            return dateB - dateA;
        });

        setUser(props.loggedInUser);
        setProducts(products);
        setLinks(links);
        setProductsLinks(filteredProductsLinks);
        setFilteredProducts(filteredProductsLinks);
        setLoading(false);
    }

    function isValidDate(date) {
        return date instanceof Date && !isNaN(date);
    }

    async function fetchUser() {
        let user = await getAuthorizedUserData();
        return user;
    }

    async function fetchProducts() {
        let basePath = props.loggedInUser ? "/Products/GetUserMerchantProductsAuthorized" : "/Products/GetUserMerchantProducts";
        let url = `${basePath}?userName=${props.loggedInUser.userName}`;
        //let url = `/Products/GetUserMerchantProducts?userName=pterracina&skip=${skip}&take=${take}`;
        let products = await getRequest(url);
        if (products) {
            products.forEach(product => product.user = props.loggedInUser);
        }

        return products;
    }

    async function fetchLinks() {
        const url = `/Products/GetMerchantLinksByUserId?userId=${props.loggedInUser.id}`;
        const links = await getRequest(url);

        if (!Array.isArray(links)) return [];

        return links.map(link => ({
            ...link,
            user: props.loggedInUser,
            shareCode: `link-${link.id}`
        }));
    }

    useEffect(() => {
        loadData(0, take);
    }, [])

    useEffect(() => {
        if (props.searchFilter.length !== 0 || searchProp !== props.searchFilter) {
            loadSearch(props.searchFilter);
        }
        setSearchProp(props.searchFilter);
    }, [props.searchFilter])


    async function loadSearch(filter) {
        setLoading(true)

        let filteredProductsLinks = productsLinks;

        filteredProductsLinks = filteredProductsLinks.filter(p => {
            const filterLowerCase = filter.toLowerCase();
            return (p.merchantName?.toLowerCase().includes(filterLowerCase) ?? false) ||
                ((!!(p.logoUrl) && p.description?.toLowerCase().includes(filterLowerCase)) ?? false) ||
                (p.manufacturer?.toLowerCase().includes(filterLowerCase) ?? false) ||
                (p.name?.toLowerCase().includes(filterLowerCase) ?? false) ||
                (p.merchant?.toLowerCase().includes(filterLowerCase) ?? false);
        });

        filteredProductsLinks = filteredProductsLinks.sort((a, b) => {
            let dateA = isValidDate(new Date(a.modifiedDate)) ? new Date(a.modifiedDate) : new Date(a.createdDate);
            let dateB = isValidDate(new Date(b.modifiedDate)) ? new Date(b.modifiedDate) : new Date(b.createdDate);

            return dateB - dateA;
        });
        setFilteredProducts(filteredProductsLinks);
        setLoading(false);
    }
    function handleSelect(product) {
        props.selectProduct(product);
    }

    function isProductSelected(productShareCode) {
        let found = props.selectedProducts.find((product) => {
            return product.shareCode === productShareCode
        });
        if (found === undefined) {
            return false;
        } else {
            return true;
        }
    }

    function isProductExisting(productShareCode) {
        if (productShareCode.includes("link-")) {
            const exists = props.existingProducts.find((prod) => prod.shareCode === productShareCode);
            return !!(exists) ? true : false;
        }

        var existing = props.existingProducts.find((prod) => prod.userMerchantProduct?.coupon === productShareCode);
        if (existing === undefined) {
            return false
        }
        else {
            return true;
        }
    }

    function mapProducts() {
        if (filteredProducts.length > 0) {

            return filteredProducts.map((product, i) => {

                return (
                    <div key={i} className="col-6 col-md-3 px-1">
                        <ProductSelectCard product={product}
                            arrayKey={i}
                            select={handleSelect}
                            isSelected={isProductSelected(product.shareCode)}
                            isExisting={isProductExisting(product.shareCode)}
                            loggedInUser={props.loggedInUser}
                        />
                    </div>
                )

            })
        }
    }

    if (loading) {
        return <LoadSpinner />
    } else if (!loadingMore && props.searchFilter?.length > 0 && filteredProducts.length === 0) { 
        return (
            <div>
                <div className="container">
                    <div className="row mx-0 mt-0">
                        <div className="col-12">
                            <div className="row">
                                <span className="w-100 text-center">
                                    No products in your inventory match your search criteria. Try again with a new search.
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    } else if (!loadingMore && productsLinks.length === 0) {
        return (
            <div>
                <div className="container">
                    <div className="row mx-0 mt-0">
                        <div className="col-12">
                            <div className="row">
                                <span className="w-100 text-center">
                                    Looks like you haven't added any products yet! Click here to get started and products from our partners that you can include in posts and lockers
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>);
    }
    return (        
        <div>
            <div className="container add-product-to-post-modal-content" id="scrollableProductModal">
                <div className="row mx-0">
                    <div className="col-12">
                        <div className="row">
                            {mapProducts()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductsSelectorForm;